import {lpad} from "../../../utils/js-utils";

const pad = (n: number) => lpad(String(n), '0', 2);

export const monthLabel = (d: Date) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}`;

/**
 * The month compared with the one before it, in the selected year: this month for the current year, December
 * for a past year, January for a future one.
 */
export function comparedMonth(year: number, thisMonth: Date): Date {
    if (year === thisMonth.getFullYear()) return thisMonth;
    return new Date(year, year < thisMonth.getFullYear() ? 11 : 0);
}

/** The two compared months: the one before `comparedMonth` and that month itself (across a year end too). */
export function pipelineMonths(year: number, thisMonth: Date): [Date, Date] {
    const after = comparedMonth(year, thisMonth);
    return [new Date(after.getFullYear(), after.getMonth() - 1), after];
}

/** The last day of each compared month (`YYYY-MM-DD`), the days the pipeline is asked for. */
export function pipelineDays(year: number, thisMonth: Date): string[] {
    return pipelineMonths(year, thisMonth).map(m => {
        const last = new Date(m.getFullYear(), m.getMonth() + 1, 0);
        return `${last.getFullYear()}-${pad(last.getMonth() + 1)}-${pad(last.getDate())}`;
    });
}
